export const getResetPassword = (state) => state.auth.resetPassword;
export const getPassword = (state) => state.auth.resetPassword.password;
export const getLoading = (state) => state.auth.resetPassword.loading;
export const getErrors = (state) => state.auth.resetPassword.errors;
